import { render, staticRenderFns } from "./StoryBoard.vue?vue&type=template&id=3f12b67c&scoped=true&"
import script from "./StoryBoard.vue?vue&type=script&lang=js&"
export * from "./StoryBoard.vue?vue&type=script&lang=js&"
import style0 from "./StoryBoard.vue?vue&type=style&index=0&id=3f12b67c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f12b67c",
  null
  
)

export default component.exports
import QSelect from 'quasar/src/components/select/QSelect.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSelect,QScrollArea,QImg});
